const data = {
  cards: [
    { cardContent: "2012", additionalText: "Founding year" },
    {
      cardContent: "3200+",
      additionalText: "Number of vendors we've worked with",
    },
    { cardContent: "3.2M+", additionalText: "Orders placed" },
    { cardContent: "A", additionalText: "Better Business Bureau rating" },
    { cardContent: "$120M+", additionalText: "Annual revenue" },
    { cardContent: "70%", additionalText: "% of purchases made on mobile" },
  ],
  iconCards: [
    { iconName: "gender", iconText: "75% M 25% F", additionalText: "Gender" },
    { iconName: "age", iconText: "25 TO 55", additionalText: "Age" },
    {
      iconName: "income",
      iconText: "$120K+",
      additionalText: "Average household income",
    },
  ],
  animatedList: [
    {
      title: "Meet Your Buyer",
      paragraph:
        "You’ll work with one of our in-house buyers to develop a merchandising strategy for your sales event designed to accomplish your marketing and business goals.",
      imgUrl: "https://cdn-s3.touchofmodern.com/partners/assets/timeline-1.jpg",
    },
    {
      title: "Photography & Copy",
      paragraph:
        "Our professional creative team has developed a visual style and voice that defines Touch of Modern. They are experts in creating compelling imagery and copy proven to drive sales and generate exposure.",
      imgUrl: "https://cdn-s3.touchofmodern.com/partners/assets/timeline-2.jpg",
    },
    {
      title: "Marketing",
      paragraph:
        "By using the most effective marketing platforms and social channels available, our team has captivated an audience of more than 16 million affluent, highly-engaged consumers. Each sales event gives our partners access to an otherwise difficult-to-reach audience, creating an opportunity to acquire long term customers.",
      imgUrl: "https://cdn-s3.touchofmodern.com/partners/assets/timeline-3.jpg",
    },
    {
      title: "Fulfillment",
      paragraph:
        "We offer a variety of logistical solutions including fulfillment through our warehouse or drop shipping for heavy or fragile items. At the end of your sales event, you will be provided with pre-paid shipping labels and assigned a shipping coordinator who will work closely with you to ensure a seamless experience.",
      imgUrl: "https://cdn-s3.touchofmodern.com/partners/assets/timeline-4.jpg",
    },
    {
      title: "Customer Service",
      paragraph:
        "Our outstanding team of support agents and fraud analysts are well-equipped to handle any questions that may come up from you, or our customers.",
      imgUrl: "https://cdn-s3.touchofmodern.com/partners/assets/timeline-5.jpg",
    },
  ],
  brands: [
    {
      brand: "grondyke",
      person: "Scott Carr, CEO",
      company: "Grondyke Soap Company",
      description:
        "We have sold a ton of soap thanks to Touch of Modern. That is not just a figure of speech, it is literally a ton of soap and growing. If you have a unique product for men, and you get an inquiry from Touch of Modern, take a deep breath, strap on your seatbelt, and enjoy the ride.",
    },
    {
      brand: "SBConsulting",
      person: "Sion Benchimol, Owner",
      company: "SB Consulting International",
      description:
        "The responsiveness and the professionalism of our contacts at Touch of Modern, from the setting up of the events to the communication while the event is running as well as the logistics, are simply excellent and made our collaboration both very efficient and pleasant.",
    },
    {
      brand: "roamproof",
      person: "Sean O'Rourke, Founder & CEO",
      company: "RoamProof",
      description:
        "Starting with flash sales, then on to consignment, they've been there since the birth of our company. Now, as we've scaled up together over the last 2 years, Touch of Modern has become one of our primary selling platforms.",
    },
    {
      brand: "iCanvas",
      person: "",
      company: "iCanvas",
      description:
        "Over time our partnership with Touch of Modern has blossomed into one of our most successful. As our artist portfolio has grown, so have the number of our events. Working with the Touch of Modern team has been rewarding, exciting, and thrilling all at the same time!",
    },
    {
      brand: "GeniusOne",
      person: "Dyan Ferman, CEO",
      company: "Genius One, Inc.",
      description:
        "Touch of Modern has been a great partner for us. There is an excellent team of buyers, account managers, and fulfillment operators working with you at every turn and willing to go that extra mile to ensure the success of the campaign.",
    },
    {
      brand: "panzera",
      person: "Roger Cooper, Co-Founder",
      company: "PANZERA Watches",
      description:
        "They are professional in every aspect from campaign set-up through to logistics and financial administration. Every process is finely tuned and designed to achieve maximum results for each sales campaign.",
    },
    {
      brand: "MarmontHill",
      person: "",
      company: "Marmont Hill Inc.",
      description:
        "The Touch of Modern team is always professional and eager to help us put together our events. They respond quickly to requests for information and they are always willing to put forth the extra effort to ensure that everything runs smoothly.",
    },
    {
      brand: "JaredLang",
      person: "",
      company: "Jared Lang",
      description:
        "This partnership has allowed me the flexibility to seamlessly push out hundreds of units in a single event, while at the same time exposing my brand to millions of men. Since working with Touch of Modern I’ve seen my brand grow from a shirting company into a Men’s Lifestyle Brand.",
    },
  ],
  brandList: ["Dyson", "Garmin", "Gerber", "Shure", "Timbuk2", "Vondom"],
};

export default data;
